import { render } from "./popUpCreditos.vue?vue&type=template&id=48c0ecce&scoped=true"
import script from "./popUpCreditos.vue?vue&type=script&lang=js"
export * from "./popUpCreditos.vue?vue&type=script&lang=js"

import "./popUpCreditos.vue?vue&type=style&index=0&id=48c0ecce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c0ecce"]])

export default __exports__